import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatAppLayout = createCustomElementWrapper('kat-app-layout', 'KatAppLayout', {}, {}, [
    'header',
    'top',
    'left',
    'bottom',
]);
